<template>

  <div class="stock-slip-lending">
     <b-row class="form-row"
      > <b-col
        cols="12"
        md="4"
        lg="4"
        class="form-col"
        > <b-form-group class="form-group-object"
          > <label class="form-label">Loại đối tượng</label> <b-form-select
            size="sm"
            v-model="stockSlip.recipientType"
            :options="contactTypes"
            value-field="value"
            text-field="text"
            class="form-control form-control-sm select-style"
            :disabled="!editable"
            @change="onRecipientTypeChange"
            > <template v-slot:first
              > <b-form-select-option :value="null"> - Loại đối tượng - </b-form-select-option>
              </template
            > </b-form-select
          > <small class="form-text text-muted"> Chọn loại đối tượng nhận hàng mượn </small>
          </b-form-group
        > </b-col
      > <b-col
        cols="12"
        md="4"
        lg="4"
        class="form-col"
        > <b-form-group class="form-group-object"
          > <label class="form-label">Đối tượng</label> <Autosuggest
            class="autosuggest-wrapper"
            :model="stockSlip.recipientName"
            :suggestions="recipients"
            placeholder="tên hoặc mã đối tượng"
            :limit="10"
            @select="onRecipientSelect"
            @change="onRecipientInputChange"
            suggestionName="text"
            :disabled="!editable || !stockSlip.recipientType"
          /> </b-form-group
        > </b-col
      > <b-col
        cols="12"
        md="4"
        lg="4"
        class="form-col"
        > <b-form-group class="required-control form-group-object"
          > <label class="form-label">Cửa hàng</label> <Autosuggest
            class="autosuggest-wrapper"
            :model="stockSlip.sourceWarehouseName"
            :suggestions="stores"
            placeholder="Chọn cửa hàng"
            :limit="200"
            @select="onSelectedSourceWarehouse"
            @change="onInputChangeSourceWarehouse"
            suggestionName="name"
            :disabled="!editable"
          /> </b-form-group
        > </b-col
      > </b-row
    > <b-row class="form-row"
      > <b-col
        cols="12"
        md="4"
        lg="4"
        class="form-col"
        > <b-form-group class="required-control form-group-object"
          > <label class="form-label">Lý do</label> <Autosuggest
            class="autosuggest-wrapper"
            :model="stockSlip.reasonName"
            :suggestions="reasons"
            placeholder="Chọn lý do"
            :limit="200"
            @select="onSelectedReason"
            @change="onInputChangeReason"
            suggestionName="name"
            :disabled="!editable"
          /> </b-form-group
        > </b-col
      > <b-col
        cols="12"
        md="4"
        lg="4"
        class="form-col"
        > <b-form-group class="form-group-object"
          > <label class="form-label">Ngày hẹn trả</label> <date-picker
            class="form-control form-control-sm date-picker-input"
            placeholder="Chọn ngày"
            :config="dpConfigs.date"
            :value="stockSlip.expectedReturnAt"
            @input="onExpectedReturnAtChange"
            :disabled="!editable"
          /> </b-form-group
        > </b-col
      > <b-col
        cols="12"
        md="4"
        lg="4"
        class="form-col"
      ></b-col
      > </b-row
    > <b-row class="form-row"
      > <b-col cols="12"
        > <b-form-group class="form-group-notes"
          > <label class="form-label">Ghi chú</label> <b-form-textarea
            size="sm"
            v-model="stockSlip.notes"
            placeholder="Thêm nội dung ghi chú..."
            :rows="4"
            :max-rows="6"
            :disabled="!editable"
            class="form-control form-control-sm"
          /> </b-form-group
        > </b-col
      > </b-row
    >
  </div>

</template>

<script>
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import timeUtils from '@/utils/date'

  export default {
    props: {
      stockSlip: { type: Object, required: true },
      stores: { type: Array, default: () => [] },
      reasons: { type: Array, default: () => [] },
      contactTypes: { type: Array, default: () => [] },
      recipients: { type: Array, default: () => [] },
      editable: { type: Boolean, default: true },
    },
    data() {
      return {
        dpConfigs: {
          date: timeUtils.DP_CONFIG.date,
        },
      }
    },
    components: { Autosuggest },
    methods: {
      onRecipientTypeChange() {
        this.$emit('onRecipientTypeChange')
      },
      onRecipientSelect(data) {
        this.$emit('onRecipientSelect', data)
      },
      onRecipientInputChange(data) {
        this.$emit('onRecipientInputChange', data)
      },
      onExpectedReturnAtChange(value) {
        this.$emit('onExpectedReturnAtChange', value)
      },
      onSelectedSourceWarehouse(data) {
        this.$emit('onSelectedSourceWarehouse', data)
      },
      onInputChangeSourceWarehouse(data) {
        this.$emit('onInputChangeSourceWarehouse', data)
      },
      onSelectedReason(data) {
        this.$emit('onSelectedReason', data)
      },
      onInputChangeReason(data) {
        this.$emit('onInputChangeReason', data)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .stock-slip-lending {
  padding: 0.5rem 0;
}

.form-row {
  margin-bottom: 1.25rem;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-col {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

@media (max-width: 991px) {
  .form-col {
    padding-left: 0;
    padding-right: 0;
  }
}

.form-group-object,
.form-group-notes {
  margin-bottom: 0;
}

.form-group-object .form-label,
.form-group-notes .form-label {
  font-weight: 600;
  font-size: 0.875rem;
  color: #3f4254;
  margin-bottom: 0.5rem;
  display: block;
  letter-spacing: 0.01em;
}

.form-text {
  font-size: 0.75rem;
  margin-top: 0.375rem;
  display: block;
  color: #a1a5b7;
  line-height: 1.3;
}

.date-picker-input,
.select-style {
  min-height: 2.25rem;
  border-radius: 0.42rem;
  border: 1px solid #e4e6ef;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:hover:not(:disabled) {
    border-color: #b5b5c3;
  }

  &:focus {
    border-color: #3699ff;
    box-shadow: 0 0 0 0.2rem rgba(54, 153, 255, 0.15);
    outline: none;
  }
}

.autosuggest-wrapper {
  width: 100%;
}

::v-deep .autosuggest-wrapper .autosuggest__input {
  min-height: 2.25rem;
  border-radius: 0.42rem;
  border: 1px solid #e4e6ef;
  padding: 0.4rem 0.75rem;
  font-size: 0.875rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:hover:not(:disabled) {
    border-color: #b5b5c3;
  }

  &:focus {
    border-color: #3699ff;
    box-shadow: 0 0 0 0.2rem rgba(54, 153, 255, 0.15);
    outline: none;
  }
}

.date-picker-input {
  width: 100%;
}

.select-style {
  width: 100%;
}

.form-group-notes .form-control {
  min-height: 5rem;
  border-radius: 0.42rem;
  border: 1px solid #e4e6ef;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  resize: vertical;
  transition: border-color 0.15s ease-in-out;

  &:focus {
    border-color: #3699ff;
    box-shadow: 0 0 0 0.2rem rgba(54, 153, 255, 0.15);
    outline: none;
  }
}

.required-control .form-label::after {
  content: ' *';
  color: #f64e60;
  font-weight: 600;
}
</style>

